import { NavigationContextFactory } from './navigationContextFactory';

export const navigationContextDependencies = {
  navigationInteractor: NavigationContextFactory.navigationInteractor(),
};
